/* eslint-disable max-len */

import React from 'react';
import { Container } from 'semantic-ui-react';
import GridCentered from '../components/GridCentered';

const ContainerPage = () => (
	<div className="containerCenter">
		<Container>
			<GridCentered />
		</Container>
	</div>
);

export default ContainerPage;



// WEBPACK FOOTER //
// ./src/container/Container.js